import {AUDIO, ENCODING_TARGET, SUBTITLE} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ} from '@constants/variables';

export const authorizationEncodingTargetReadObject = {
    [ENCODING_TARGET]: SECURITY_PRIVILEGES_READ,
};

export const authorizationAudioReadObject = {
    [AUDIO]: SECURITY_PRIVILEGES_READ,
};

export const authorizationSubtitleReadObject = {
    [SUBTITLE]: SECURITY_PRIVILEGES_READ,
};
